var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMovement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 77,
    viewBox: "0 0 70 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.543 0.504)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.907,66.852l-9.794-14.1-.589-.81c-.295-.486-1.031-2.268-2.062-4.7h.368A1.556,1.556,0,0,0,59.861,45.3a1.392,1.392,0,0,0-1.767-1.134l-.884.162c-.589-1.3-1.031-2.593-1.62-4.051l.442-.162a1.556,1.556,0,0,0,1.031-1.944A1.392,1.392,0,0,0,55.3,37.037l-.884.405c-.442-1.3-.884-2.755-1.325-4.051l.589-.162a1.556,1.556,0,0,0,1.031-1.944,1.392,1.392,0,0,0-1.767-1.134l-.736.162c0-.162-.147-.324-.147-.486a18.392,18.392,0,0,1-.589-2.755v-1.3c.442-2.593.736-5.914-.884-7.535-1.62-1.782-4.934-.972-6.259,1.944l-.736,1.782c0,.162-.147.162-.295.162-9.352-2.106-11.414-4.213-12.813-5.266-2.356-1.782-1.767-4.051-1.473-5.59.442-2.268.884-4.213-1.62-7.535a2.451,2.451,0,0,0-3.682-.486C20.465,6.494,10.451,15.487,8.242,18c-5.67,2.106-7,7.291-4.639,10.451C18.183,48.7,42.262,69.93,52.645,75.844c5.081,2.755,13.549,5.266,17.673.972C71.937,75.358,74,71.389,70.907,66.852ZM25.473,6.17c1.325,1.944,1.178,2.755.884,4.537-.295,1.62-1.473,5.752,2.5,8.831,3.093,3.241,10.088,4.942,13.991,5.914a3.1,3.1,0,0,0,3.535-1.944l.736-1.782c.442-.972,1.325-1.3,1.62-.972s.589,1.944,0,4.7a6.74,6.74,0,0,0,0,2.43c.147.972.442,1.944.589,2.917,0,.162,0,.162.147.324l-2.945.81A1.556,1.556,0,0,0,45.5,33.878a1.392,1.392,0,0,0,1.767,1.134l3.093-.81c.442,1.3.884,2.755,1.325,4.051l-2.8.648a1.556,1.556,0,0,0-1.031,1.944,1.392,1.392,0,0,0,1.767,1.134l3.093-.81c.589,1.458,1.031,2.755,1.62,4.051l-2.651.81a1.556,1.556,0,0,0-1.031,1.944,1.392,1.392,0,0,0,1.767,1.134l3.387-.972c1.325,3.079,2.356,5.266,2.5,5.428,0,.162.147.162.147.324l10.53,15.069a4.055,4.055,0,0,1,.147,5.1c-5.081-1.3-13.4-7.048-15.022-8.507C28.86,43.276,18.183,28.612,11.04,19.619,13.249,17.188,19.655,11.436,25.473,6.17Zm28.5,66.839c-9.941-5.671-32.989-25.763-48.158-46.5-1.473-1.944.736-4.213,2.8-5.1,6.259,7.859,17.231,23.333,43.372,46.585a62.992,62.992,0,0,0,12.813,8.021C61.113,76.168,56.032,74.062,53.97,73.009Z",
    transform: "translate(-2.492 -2.629)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.507,23.572l3.387,4.213a1.345,1.345,0,0,0,2.062.162,1.685,1.685,0,0,0,.147-2.268l-3.387-4.213a1.345,1.345,0,0,0-2.062-.162A2.1,2.1,0,0,0,21.507,23.572Z",
    transform: "translate(-7.437 -6.095)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.153 34.085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.218,84.241H42.173a1.628,1.628,0,0,1,0-3.241H53.218a1.628,1.628,0,0,1,0,3.241Z",
    transform: "translate(-12.718 -51.591)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.939,84.241H19.894a1.628,1.628,0,0,1,0-3.241H30.939a1.628,1.628,0,0,1,0,3.241Z",
    transform: "translate(-6.845 -51.591)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.559,72.141H4.573a1.628,1.628,0,0,1,0-3.241H24.559a1.628,1.628,0,0,1,0,3.241Z",
    transform: "translate(-2.805 -49.294)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.386,60.041H10.573a1.628,1.628,0,0,1,0-3.241H23.386a1.628,1.628,0,0,1,0,3.241Z",
    transform: "translate(-4.387 -46.997)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.407,47.941H4.173a1.628,1.628,0,0,1,0-3.241H8.407a1.628,1.628,0,0,1,0,3.241Z",
    transform: "translate(-2.7 -44.7)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovement);
export default __webpack_public_path__ + "static/media/movement.b0cd0db89f6a3b60f06e630d305d56c8.svg";
export { ForwardRef as ReactComponent };